/**
 * OrganizationFlow resumes mid-journey when it finds an org id in local/session storage
 * (see getResumeOrgId in pages/organizationFlow/index.tsx). Those mirrors are separate from
 * redux-persist; clear them on admin logout so a new login starts at org selection.
 */
const RESUME_ORG_ID_KEYS = ['org_id', 'orgId', 'organizationId', 'spence_org_id'] as const;

const ADMIN_UNIT_CONTEXT_KEYS = ['unitId'] as const;

export function clearAdminOrganizationResumeStorage(): void {
  if (typeof window === 'undefined') {
    return;
  }

  for (const key of [...RESUME_ORG_ID_KEYS, ...ADMIN_UNIT_CONTEXT_KEYS]) {
    try {
      window.localStorage?.removeItem(key);
      window.sessionStorage?.removeItem(key);
    } catch {
      // Ignore storage errors (private mode, quota, etc.)
    }
  }
}
